
//#region aggregate
export interface AggregateDescriptor {
  field: string;
  aggregate: 'count' | 'sum' | 'average' | 'min' | 'max';
}

export interface AggregateResult {
    [fieldName: string]: {
        count?: number;
        sum?: number;
        average?: number;
        min?: number;
        max?: number;
    };
}

// export function aggregateBy<T>(
//     data: T[],
//     descriptors: AggregateDescriptor[],
//     transformers?: (reduce: Combinator) => Transformer) : T[] {
//   return [...data].sort((a, b) => {
//     for (const {field, dir} of descriptors) {
//       const aV = a[field];
//       const bV = b[field];
//       if (aV < bV) return dir === 'asc' ? -1 : 1;
//       if (aV > bV) return dir === 'asc' ? 1 : -1;
//       // if equal continue to next description
//     }
//     return 0;
//   });
// }

export function aggregateBy2<T>(data: T[], descriptors: AggregateDescriptor[]): AggregateResult {
  const result: AggregateResult = {};

  for (const { field, aggregate } of descriptors) {
    const values = data.map(item => item[field]).filter(v => typeof v === 'number') as number[];

    if (!result[field]) {
      result[field] = {};
    }

    switch (aggregate) {
      case 'sum':
        result[field].sum = values.reduce((acc, val) => acc + val, 0);
        break;
      case 'average':
        result[field].average = values.length ? values.reduce((acc, val) => acc + val, 0) / values.length : 0;
        break;
      case 'min':
        result[field].min = values.length ? Math.min(...values) : undefined;
        break;
      case 'max':
        result[field].max = values.length ? Math.max(...values) : undefined;
        break;
      case 'count':
        result[field].count = values.length;
        break;
    }
  }

  return result;
}

export function aggregateBy<T>(data: T[], descriptors: AggregateDescriptor[]) {
  const result: Record<string, number> = {};

  for (const { field, aggregate } of descriptors) {
    const values = data.map(item => item[field]).filter(v => typeof v === 'number');

    switch (aggregate) {
      case 'sum':
        result[`${field}_sum`] = values.reduce((acc, val) => acc + val, 0);
        break;
      case 'average':
        result[`${field}_average`] = values.length ? values.reduce((acc, val) => acc + val, 0) / values.length : 0;
        break;
      case 'min':
        result[`${field}_min`] = Math.min(...values);
        break;
      case 'max':
        result[`${field}_max`] = Math.max(...values);
        break;
      case 'count':
        result[`${field}_count`] = values.length;
        break;
    }
  }

  return result;
}

//#endregion

//#region orderBy

export function orderBy(data: any[], field: string, direction: 'asc' | 'desc' = 'asc') {
  return [...data].sort((a, b) => {
    if (a[field] < b[field]) return direction === 'asc' ? -1 : 1;
    if (a[field] > b[field]) return direction === 'asc' ? 1 : -1;
    return 0;
  });
}

//endregion

//#region filterBy

export function filterBy(data: any[], field: string, value: any) {
  return data.filter(item =>
    item[field]?.toString().toLowerCase().includes(value.toString().toLowerCase()),
  );
}

//endregion

export const isPresent = (value) => value !== null && value !== undefined;
export const isBlank = (value) => value === null || value === undefined;
export const isArray = (value) => Array.isArray(value);
export const isFunction = (value) => typeof value === 'function';
export const isString = (value) => typeof value === 'string';
export const isTruthy = (value) => !!value;
export const isNullOrEmptyString = (value) => isBlank(value) || value.trim().length === 0;
export const isNotNullOrEmptyString = (value) => !isNullOrEmptyString(value);
export const isNumeric = (value) => !isNaN(value - parseFloat(value));
export const isDate = (value) => value && value.getTime;

export var isStringValue = function (x) { return isString(x.value); };
export var isDateValue = function (x) { return isDate(x.value); };
